export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry.78e74c56cacdb81538de.bundle.worker.js");
}
